import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-deceased-cm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-deceased-cm.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { BehaviorSubject } from "rxjs";
import * as AflaPortalDocumentConstants from "../../../../../core/settings/components/afla-portal-documents/afla-portal-documents.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { ViewApplicationDeceasedCmConstants } from "./view-application-deceased-cm.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { EditDeceasedNameComponent } from "./edit-deceased-name/edit-deceased-name.component";
import { AddDeceasedNameComponent } from "./add-deceased-name/add-deceased-name.component";
import { ViewApplicationService } from "../../../view-application.service";
import { DeceasedNamesHeadingEnumHeadingLookup } from "./deceased-names-heading.model";
import { DatePipe } from "@angular/common";
import { CemeteryService } from "../../../../../shared/services/modules/cemetery.service";
import { take, takeUntil } from "rxjs/operators";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
let ViewApplicationDeceasedCmComponent = class ViewApplicationDeceasedCmComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    viewApplicationService;
    appController;
    modalService;
    datePipe;
    cemeteryService;
    changeDetectorRefs;
    deceasedForm;
    validationMessages = ViewApplicationDeceasedCmConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    // public tableDataSource: Observable<ICmDeceasedName[]>;
    tableDataSource = new BehaviorSubject([]);
    // @ts-ignore
    tableMapper;
    tableSelection = [];
    deleteLabel = SharedConstants.DELETE_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    addLabel = SharedConstants.ADD_LABEL;
    particularDetailsLabel = ViewApplicationDeceasedCmConstants.PARTICULAR_DETAILS_LABEL;
    captureParticularDetailsLabel = ViewApplicationDeceasedCmConstants.CAPTURE_PARTICULAR_DETAILS_LABEL;
    sexLabel = ViewApplicationDeceasedCmConstants.SEX_LABEL;
    nationalityLabel = ViewApplicationDeceasedCmConstants.NATIONALITY_LABEL;
    identificationTypeLabel = ViewApplicationDeceasedCmConstants.IDENTIFICATION_TYPE_LABEL;
    idNumberLabel = ViewApplicationDeceasedCmConstants.ID_NUMBER_LABEL;
    dateOfBirthLabel = ViewApplicationDeceasedCmConstants.DATE_OF_BIRTH_LABEL;
    dateOfDeathLabel = ViewApplicationDeceasedCmConstants.DATE_OF_DEATH_LABEL;
    placeOfBirthLabel = ViewApplicationDeceasedCmConstants.PLACE_OF_BIRTH_LABEL;
    placeOfDeathLabel = ViewApplicationDeceasedCmConstants.PLACE_OF_DEATH_LABEL;
    maidenNameLabel = ViewApplicationDeceasedCmConstants.MAIDEN_NAME_LABEL;
    provinceOfDeathLabel = ViewApplicationDeceasedCmConstants.PROVINCE_OF_DEATH_LABEL;
    burialOrderNumberLabel = ViewApplicationDeceasedCmConstants.BURIAL_ORDER_NUMBER_LABEL;
    serialNumberLabel = ViewApplicationDeceasedCmConstants.SERIAL_NUMBER_LABEL;
    verticalPositionLabel = ViewApplicationDeceasedCmConstants.VERTICAL_POSITION_LABEL;
    nameOfUndertakerLabel = ViewApplicationDeceasedCmConstants.NAME_OF_UNDERTAKER_LABEL;
    sexFormControlName = ViewApplicationDeceasedCmConstants.SEX_FORM_CONTROL_NAME;
    nationalityFormControlName = ViewApplicationDeceasedCmConstants.NATIONALITY_FORM_CONTROL_NAME;
    identificationTypeFormControlName = ViewApplicationDeceasedCmConstants.IDENTIFICATION_TYPE_FORM_CONTROL_NAME;
    idNumberFormControlName = ViewApplicationDeceasedCmConstants.ID_NUMBER_FORM_CONTROL_NAME;
    dateOfBirthFormControlName = ViewApplicationDeceasedCmConstants.DATE_OF_BIRTH_FORM_CONTROL_NAME;
    dateOfDeathFormControlName = ViewApplicationDeceasedCmConstants.DATE_OF_DEATH_FORM_CONTROL_NAME;
    placeOfBirthFormControlName = ViewApplicationDeceasedCmConstants.PLACE_OF_BIRTH_FORM_CONTROL_NAME;
    placeOfDeathFormControlName = ViewApplicationDeceasedCmConstants.PLACE_OF_DEATH_FORM_CONTROL_NAME;
    maidenNameFormControlName = ViewApplicationDeceasedCmConstants.MAIDEN_NAME_FORM_CONTROL_NAME;
    provinceOfDeathFormControlName = ViewApplicationDeceasedCmConstants.PROVINCE_OF_DEATH_FORM_CONTROL_NAME;
    burialOrderNumberFormControlName = ViewApplicationDeceasedCmConstants.BURIAL_ORDER_NUMBER_FORM_CONTROL_NAME;
    serialNumberFormControlName = ViewApplicationDeceasedCmConstants.SERIAL_NUMBER_FORM_CONTROL_NAME;
    verticalPositionFormControlName = ViewApplicationDeceasedCmConstants.VERTICAL_POSITION_FORM_CONTROL_NAME;
    nameOfUndertakerFormControlName = ViewApplicationDeceasedCmConstants.NAME_OF_UNDERTAKER_FORM_CONTROL_NAME;
    deleteSuccessMessage = SharedConstants.REMOVE_SUCCESS;
    removeDialogTitle = AflaPortalDocumentConstants.REMOVE_DIALOG_TEXT;
    removeContent = `${SharedConstants.REMOVE_MESSAGE} name(s)?`;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    sexTypes = [];
    countryOptions = LookupConstants.COUNTRIES;
    idTypes = [];
    verticalPositionTypes = [];
    provinceOptions = LookupConstants.PROVINCE;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    application;
    modalOptions = {
        size: "lg",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    today = new Date();
    pauperApplicationTypeName = "";
    requiredFieldState = {
        sex: true,
        nationality: true,
        identificationType: true,
        idNumber: true,
        dateOfBirth: true,
        placeOfBirth: true,
        burialOrderNumber: true,
        verticalPosition: true
    };
    getApplicationSaveDeceasedObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, viewApplicationService, appController, modalService, datePipe, cemeteryService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this.cemeteryService = cemeteryService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        if (this.aflaModuleStrategyService.lookups.has("sexTypes")) {
            this.sexTypes = this.aflaModuleStrategyService.lookups.get("sexTypes");
            this.idTypes = this.aflaModuleStrategyService.lookups.get("idTypes");
            this.verticalPositionTypes = this.aflaModuleStrategyService.lookups.get("verticalPositionTypes");
            this.getApplication();
        }
        else {
            this.getLookups();
        }
        this.initializeColumnToObjectMapping();
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        this.pauperApplicationTypeName = this.getPauperApplicationTypeName(stepMeta);
        this.updateValidations();
    }
    arrayReturned(array) {
        this.tableSelection = array;
    }
    onBtnRemoveClicked($event) {
        if (this.tableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        const deletedDocument = this.tableSelection;
        let index = 0;
        const itemsAlreadyOnTable = this.tableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === deletedDocument) {
                index = i;
            }
        }
        const options = {
            size: "sm",
            centered: true,
            keyboard: false,
            backdrop: "static"
        };
        const title = this.removeDialogTitle;
        const contentMessage = this.removeContent;
        const dialogRef = this.modalService.open(PopUpComponent, options);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.contentMessage = contentMessage;
        dialogRef.componentInstance.data = index;
        dialogRef.result.then((deletedIndex) => {
            this.changeDetectorRefs.markForCheck();
            if (deletedIndex !== undefined && deletedIndex !== null) {
                itemsAlreadyOnTable.splice(deletedIndex, 1);
                const allItems = [...itemsAlreadyOnTable];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
            }
        }).catch((res) => {
        });
    }
    onBtnEditClicked($event) {
        if (this.tableSelection.length === 0) {
            this.appController.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        if (this.tableSelection.length > 1) {
            this.appController.showMessage(this.selectOneDocMessage, AlertType.Warning);
            return;
        }
        let index = 0;
        const itemsAlreadyOnTable = this.tableDataSource.getValue();
        for (let i = 0; i < itemsAlreadyOnTable.length; i++) {
            if (itemsAlreadyOnTable[i] === this.tableSelection[0]) {
                index = i;
            }
        }
        const modalRef = this.modalService.open(EditDeceasedNameComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Edit particular name";
        modalRef.componentInstance.deceasedName = this.tableSelection[0];
        modalRef.componentInstance.editedIndex = index;
        modalRef.result.then((updatedName) => {
            this.changeDetectorRefs.markForCheck();
            if (updatedName) {
                itemsAlreadyOnTable[updatedName[0]] = updatedName[1];
                const allItems = [...itemsAlreadyOnTable];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
            }
        }).catch((res) => {
        });
    }
    onBtnAddClicked($event) {
        const modalRef = this.modalService.open(AddDeceasedNameComponent, this.modalOptions);
        modalRef.componentInstance.modalTitle = "Add particular name";
        modalRef.result.then(newDeceasedName => {
            if (newDeceasedName) {
                const itemsAlreadyOnTable = this.tableDataSource.getValue();
                const allItems = [...itemsAlreadyOnTable, newDeceasedName];
                this.tableDataSource.next(allItems);
                this.tableSelection = [];
                this.changeDetectorRefs.detectChanges();
                this.syncDeceasedNames();
            }
        }).catch((res) => {
        });
    }
    syncDeceasedNames() {
        const items = this.tableDataSource.getValue();
        const formItems = this.deceasedForm.get("deceasedNames");
        formItems.clear();
        items.forEach(item => {
            const newItem = new FormGroup({
                id: new FormControl(item.id),
                deceasedId: new FormControl(item.deceasedId),
                deleted: new FormControl(item.deleted),
                name: new FormControl(item.name),
                surname: new FormControl(item.surname),
                startDate: new FormControl(item.startDate)
            });
            formItems.push(newItem);
        });
    }
    onBtnSaveClicked($event) {
        if (this.deceasedForm.valid) {
            const deceasedNames = [];
            const namesArray = this.deceasedForm.get("deceasedNames");
            namesArray.controls.forEach((item) => {
                if (item.get("id") !== null && item.get("id").value !== null) {
                    const deceasedName = {
                        id: item.get("id").value,
                        deceasedId: item.get("deceasedId").value,
                        deleted: item.get("deleted").value,
                        name: item.get("name").value,
                        surname: item.get("surname").value,
                        startDate: item.get("startDate").value
                    };
                    deceasedNames.push(deceasedName);
                }
                else {
                    const deceasedName = {
                        name: item.get("name").value,
                        surname: item.get("surname").value,
                        startDate: item.get("startDate").value
                    };
                    deceasedNames.push(deceasedName);
                }
                ;
            });
            const idType = this.deceasedForm.get("identificationType").value ? this.deceasedForm.get("identificationType").value.value : null;
            const sex = this.deceasedForm.get("sex").value ? this.deceasedForm.get("sex").value.value : null;
            const verticalPosition = this.deceasedForm.get("verticalPosition").value ? this.deceasedForm.get("verticalPosition").value.value : null;
            const deceased = {
                sex,
                nationality: this.deceasedForm.get("nationality").value,
                idType,
                idNumber: this.deceasedForm.get("idNumber").value,
                burialOrderNumber: this.deceasedForm.get("burialOrderNumber").value,
                serialNo: this.deceasedForm.get("serialNumber").value,
                verticalPosition,
                dateOfBirth: this.deceasedForm.get("dateOfBirth").value,
                dateOfDeath: this.deceasedForm.get("dateOfDeath").value,
                placeOfBirth: this.deceasedForm.get("placeOfBirth").value,
                placeOfDeath: this.deceasedForm.get("placeOfDeath").value,
                maidenName: this.deceasedForm.get("maidenName").value,
                undertaker: this.deceasedForm.get("nameOfUndertaker").value,
                provinceOfDeath: this.deceasedForm.get("provinceOfDeath").value,
                deceasedNames
            };
            const params = {
                deceased
            };
            this.getApplicationSaveDeceasedObservableSubscription =
                this.cemeteryService.getApplicationSaveDeceasedObservable(this.application.id, params)
                    .subscribe({
                    next: () => {
                        this.getApplication();
                        setTimeout(() => this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success), 500);
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationDeceasedCmConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getApplication() {
        const params = {
            $expand: `deceased($expand=deceasedNames)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDeceasedCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    handleRouteChange() {
    }
    updateValidations() {
        const burialTypeText = this.getApplicationBurialTypeText();
        this.applyBurialTypeValidationState(burialTypeText);
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService
            .getStepMetaObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    getApplicationBurialTypeText() {
        if (this.application === null || this.application === undefined) {
            return "";
        }
        if (this.application.type === null || this.application.type === undefined) {
            return "";
        }
        return this.application.type;
    }
    applyBurialTypeValidationState(burialTypeText) {
        const isPauperBurialType = this.isPauperBurialType(burialTypeText);
        if (isPauperBurialType) {
            this.clearPauperOptionalValidators();
        }
        else {
            this.applyRequiredValidators();
        }
        this.requiredFieldState = this.buildRequiredFieldState(!isPauperBurialType);
        this.deceasedForm.updateValueAndValidity({ emitEvent: false });
        this.changeDetectorRefs.detectChanges();
    }
    isPauperBurialType(burialTypeText) {
        const normalizedPauperApplicationTypeName = this.pauperApplicationTypeName.trim().toLowerCase();
        if (normalizedPauperApplicationTypeName === "") {
            return false;
        }
        const normalizedBurialType = burialTypeText.toLowerCase();
        return normalizedBurialType.includes(normalizedPauperApplicationTypeName);
    }
    getPauperApplicationTypeName(stepMeta) {
        if (stepMeta === null || stepMeta === undefined) {
            return "";
        }
        const metadataValue = stepMeta[ViewApplicationDeceasedCmConstants.PAUPER_APPLICATION_TYPE_NAME_METADATA_KEY];
        if (metadataValue === null || metadataValue === undefined) {
            return "";
        }
        return String(metadataValue);
    }
    clearPauperOptionalValidators() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        optionalControlNames.forEach((controlName) => {
            this.clearControlValidators(controlName);
        });
        this.clearControlValidators(ViewApplicationDeceasedCmConstants.DECEASED_NAMES_FORM_CONTROL_NAME);
    }
    applyRequiredValidators() {
        const optionalControlNames = this.getPauperOptionalControlNames();
        optionalControlNames.forEach((controlName) => {
            this.applyRequiredValidator(controlName);
        });
        this.applyDeceasedNamesRequiredValidator();
    }
    getPauperOptionalControlNames() {
        return [
            ...ViewApplicationDeceasedCmConstants.PAUPER_OPTIONAL_FORM_CONTROL_NAMES,
            ...ViewApplicationDeceasedCmConstants.PAUPER_LEGACY_OPTIONAL_FORM_CONTROL_NAMES
        ];
    }
    clearControlValidators(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyRequiredValidator(controlName) {
        const control = this.deceasedForm.get(controlName);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.required]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    applyDeceasedNamesRequiredValidator() {
        const control = this.deceasedForm.get(ViewApplicationDeceasedCmConstants.DECEASED_NAMES_FORM_CONTROL_NAME);
        if (control === null) {
            return;
        }
        control.setValidators([Validators.minLength(ViewApplicationDeceasedCmConstants.DECEASED_NAMES_MINIMUM_LENGTH)]);
        control.updateValueAndValidity({ emitEvent: false });
    }
    buildRequiredFieldState(required) {
        return {
            sex: required,
            nationality: required,
            identificationType: required,
            idNumber: required,
            dateOfBirth: required,
            placeOfBirth: required,
            burialOrderNumber: required,
            verticalPosition: required
        };
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("deceasedForm");
        this.deceasedForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'Sex' or name eq 'IDType' or name eq 'VerticalPosition')`,
        };
        this.viewApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDeceasedCmConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const sexTypes = [];
        const idTypes = [];
        const verticalPositionTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "Sex") {
                    sexTypes.push(JSON.parse(item.content));
                }
                if (item.name === "IDType") {
                    idTypes.push(JSON.parse(item.content));
                }
                if (item.name === "VerticalPosition") {
                    verticalPositionTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("sexTypes", sexTypes);
        this.sexTypes = sexTypes;
        this.aflaModuleStrategyService.lookups.set("idTypes", idTypes);
        this.idTypes = idTypes;
        this.aflaModuleStrategyService.lookups.set("verticalPositionTypes", verticalPositionTypes);
        this.verticalPositionTypes = verticalPositionTypes;
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = DeceasedNamesHeadingEnumHeadingLookup;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            this.updateValidations();
            if (this.application.deceased && this.application.deceased.length > 0) {
                this.deceasedForm.get("idNumber").setValue(this.application.deceased[0].idNumber);
                this.deceasedForm.get("burialOrderNumber").setValue(this.application.deceased[0].burialOrderNumber);
                this.deceasedForm.get("serialNumber").setValue(this.application.deceased[0].serialNo);
                this.deceasedForm.get("dateOfBirth").setValue(this.datePipe.transform(this.application.deceased[0].dateOfBirth, "yyyy-MM-dd"));
                if (this.application.deceased[0].dateOfDeath !== undefined && this.application.deceased[0].dateOfDeath !== null) {
                    this.deceasedForm.get("dateOfDeath").setValue(this.datePipe.transform(this.application.deceased[0].dateOfDeath, "yyyy-MM-dd"));
                }
                this.deceasedForm.get("nationality").setValue(this.application.deceased[0].nationality);
                this.deceasedForm.get("placeOfBirth").setValue(this.application.deceased[0].placeOfBirth);
                this.deceasedForm.get("placeOfDeath").setValue(this.application.deceased[0].placeOfDeath);
                this.deceasedForm.get("maidenName").setValue(this.application.deceased[0].maidenName);
                this.deceasedForm.get("nameOfUndertaker").setValue(this.application.deceased[0].undertaker);
                this.deceasedForm.get("provinceOfDeath").setValue(this.application.deceased[0].provinceOfDeath);
                this.sexTypes.forEach(item => {
                    if (item.value === this.application.deceased[0].sex) {
                        this.deceasedForm.get("sex").setValue(item);
                    }
                });
                this.idTypes.forEach(item => {
                    if (item.value === this.application.deceased[0].idType) {
                        this.deceasedForm.get("identificationType").setValue(item);
                    }
                });
                this.verticalPositionTypes.forEach(item => {
                    if (item.value === this.application.deceased[0].verticalPosition) {
                        this.deceasedForm.get("verticalPosition").setValue(item);
                    }
                });
                const nameItems = [];
                this.application.deceased[0].deceasedNames.forEach(name => {
                    const dName = {
                        id: name.id,
                        deceasedId: name.deceasedId,
                        name: name.name,
                        surname: name.surname,
                        startDate: this.datePipe.transform(new Date(name.startDate), "yyyy-MM-dd"),
                        deleted: name.deleted
                    };
                    nameItems.push(dName);
                });
                this.tableDataSource.next(nameItems);
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    dateOfBirthChanged() {
        const dob = this.deceasedForm.get(this.dateOfBirthFormControlName).value;
        const dod = this.deceasedForm.get(this.dateOfDeathFormControlName).value;
        if (dob !== null && dob !== null && dob > dod) {
            this.deceasedForm.get(this.dateOfDeathFormControlName).setValue(null);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: NgbModal },
        { type: DatePipe },
        { type: CemeteryService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDeceasedCmComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-deceased-cm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDeceasedCmComponent);
export { ViewApplicationDeceasedCmComponent };
